export const SEND_MESSAGE = '/message/add'
export const START_OVER = 'start over'
